import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <path
      transform="scale(1.5 1.5)"
      d="M7.5 1.5L5.64 5.11429L1.5 5.69571L4.5 8.52429L3.795 12.5L7.5 10.6143L11.205 12.5L10.5 8.52429L13.5 5.69571L9.36 5.11429L7.5 1.5Z"
      stroke={fill}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </g>
);

export default Icon;
